import { api } from '../axiosClient';
import type { EmployeeDetailsResponse } from './employees.types';

const EMPLOYEES_PATH = '/employees';
const USERS_PATH = '/User';

export const getEmployeeDetails = (
  userId: string,
): Promise<EmployeeDetailsResponse> =>
  api.get(`${EMPLOYEES_PATH}/${userId}/details`);

export const getEmployeeProfilePicture = (userId: string): Promise<Blob> =>
  api.get(`${USERS_PATH}/${userId}/profile-picture`, {
    responseType: 'blob',
  });
